import React, { useState, useEffect } from "react";
import { Magnifier, Xmark } from "@gravity-ui/icons";
import { usePostHog } from "posthog-js/react";
import SmartAssistModal from "../custom_components/SmartAssistModal";
import { useAuth } from "../../contexts/AuthContext";

const SearchBar = ({
  placeholder,
  className,
  value,
  onSearch,
  onClear,
  onVisibilityChange,
  fromDiscover = true,
}) => {
  const [searchTerm, setSearchTerm] = useState(value || "");
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [pageWidth, setPageWidth] = useState(window.innerWidth);
  const mdBreakpoint = 868;
  const posthog = usePostHog();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {isLoggedIn} = useAuth();
  useEffect(() => {
    setSearchTerm(value);
  }, [value]);
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
    
    // Determine which page we're on and send appropriate PostHog event
    if (fromDiscover) {
      posthog.capture("Click to Search tracks", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Discover",
        query: e.target.value
      });
    } else if (placeholder === "Search project by name") {
      posthog.capture("Project-page-search-project-by-name", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Projects",
        query: e.target.value
      });
    } else {
      posthog.capture("Click to Search tracks", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Liked tracks",
        query: e.target.value
      });
    }
  };
  const handleClear = () => {
    // Send appropriate PostHog event based on the page
    if (fromDiscover) {
      posthog.capture("Click-RemoveTypedSearch-DiscoverMainPage", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Discover"
      });
    } else if (placeholder === "Search project by name") {
      posthog.capture("Project-page-clear-search", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Projects"
      });
    } else {
      posthog.capture("Click-RemoveTypedSearch-DiscoverMainPage", {
        is_user_logged_in: isLoggedIn ? true : false,
        page: "Liked tracks"
      });
    }
    
    setSearchTerm("");
    onClear();
  };

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pageWidth <= mdBreakpoint) {
      setIsSearchVisible(false);
    }
  }, [pageWidth]);

  const toggleSearchVisibility = () => {
    const newVisibility = !isSearchVisible;
    setIsSearchVisible(newVisibility);
    onVisibilityChange(newVisibility); // Notify parent component
  };

  return (
    <>
      <div
        className="hidden md:flex relative items-center w-full"
        id="search-bar"
      >
        <Magnifier className="absolute left-3 text-gray-500" />
        <input
          type="text"
          className={`pl-8 ${className}`}
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearch}
        />
        {/* {!searchTerm && fromDiscover && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="absolute right-[18px] text-[#878188] underline hover:text-white flex items-center justify-center gap-1 text-sm"
          >
            smart assist
            <img src="/Smart Assist.svg" className="w-3.5 h-3.5 opacity-60 hover:opacity-100" />
          </button>
          
        )} */}

        {searchTerm && (
          <button
            onClick={handleClear}
            className="absolute right-4 text-gray-500 hover:text-white"
          >
            <Xmark />
          </button>
        )}
      </div>
      <div
        className="md:hidden relative h-8 flex items-center w-full"
        id="search-bar"
      >
        {fromDiscover ? (
          <Magnifier
            className={`absolute ${
              isSearchVisible ? `left-2.5 top-2.5` : `right-3 top-2.5`
            } text-gray-500`}
            onClick={toggleSearchVisibility}
          />
        ) : (
          <Magnifier
            className={`absolute ${
              isSearchVisible ? `left-2.5` : `right-3`
            } text-gray-500`}
            onClick={toggleSearchVisibility}
          />
        )}
        {isSearchVisible && (
          <input
            type="text"
            className={`pl-8 w-full ${className}`}
            placeholder={placeholder}
            value={searchTerm}
            onChange={handleSearch}
          />
        )}
        {isSearchVisible && (
          <button
            onClick={toggleSearchVisibility}
            className="absolute right-3 text-gray-500 hover:text-white"
          >
            <Xmark />
          </button>
        )}
      </div>
      {isModalOpen && (
        <SmartAssistModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default SearchBar;
